import {
  WixPatternsEssentials,
  WarmUpPickerParams,
  warmUpPickerStandalone as warmUpPickerStandaloneBase,
} from '@wix/bex-core';
import { version as cairoVersion } from '../version';

export function warmUpPickerStandalone(
  wixPatternsEssentials: WixPatternsEssentials,
  params: WarmUpPickerParams,
) {
  return warmUpPickerStandaloneBase(
    {
      ...wixPatternsEssentials,
      environment: {
        ...wixPatternsEssentials.environment,
        uiLibVersion: cairoVersion,
      },
    },
    params,
  );
}
